var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloudFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5242 6.21637C12.0989 4.09641 10.2349 2.5 7.99987 2.5C5.7648 2.5 3.9008 4.09642 3.47556 6.21639C1.53724 6.32914 0 7.94431 0 9.92027C0 11.9693 1.6531 13.6304 3.69231 13.6304H12.3077C14.3469 13.6304 16 11.9693 16 9.92027C16 7.94422 14.4626 6.32899 12.5242 6.21637Z",
  fill: "#509EE3"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloudFilled);
export default ForwardRef;